interface ChipProps {
  label: string
  selected?: boolean
  disabled?: boolean
  onClick?: () => void
  className?: string
}

export function Chip({
  label,
  selected = false,
  disabled = false,
  onClick,
  className,
}: ChipProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={[
        'tracking-base rounded-full border px-4 py-1 text-xs transition',
        disabled
          ? 'cursor-not-allowed border-neutral-300 bg-neutral-50 text-neutral-300'
          : selected
            ? 'border-indigo-base text-indigo-base bg-indigo-50 hover:shadow-[0_1px_4.25px_#8885ff] active:bg-indigo-100'
            : 'text-neutral-base border-indigo-100 bg-white hover:border-indigo-300 hover:text-indigo-300 hover:shadow-[0_1px_4.25px_#8885ff]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
    </button>
  )
}
